var DialogType;
(function (DialogType) {
  DialogType["Confirm"] = "confirm";
  DialogType["Form"] = "form";
  DialogType["Default"] = "default";
  DialogType["Modal"] = "modal";
  DialogType["Stepper"] = "stepper";
})(DialogType || (DialogType = {}));

export { DialogType };
